export function sortBy<Type>(key: keyof Comparable<Type>): CompareFunction {
  return (lhs: Type, rhs: Type) => {
      return asc(lhs[key], rhs[key]);
  }
}

export function asc(lhs: any, rhs: any): ComparisionOrder {
  if (typeof lhs === 'string') {
    lhs = lhs.toLowerCase();
    rhs = rhs.toLowerCase();
  }
  if ( lhs > rhs ) {
    return 1;
  }
  if (lhs < rhs) {
    return -1;
  }
  return 0;
}
export function desc(lhs: any, rhs: any): ComparisionOrder {
  return asc(lhs, rhs) * -1 as ComparisionOrder;
}

type ComparablePrimitive = number|string;
type ComparisionOrder = 0|1|-1;
type CompareFunction = (lhs: any, rhs: any) => ComparisionOrder;
type Comparable<Type> = { [Property in keyof Type]: ComparablePrimitive };
